import { UserNotificationPreferencesDTO } from '@services/DTO/UserNotificationPreferencesDTO'

export enum UserRoleDTO {
    OWNER = 'OWNER',
    MANAGER = 'MANAGER',
    STAFF = 'STAFF',
    VIEWER = 'VIEWER',
}

export class UserDTO {
    constructor(
        public id: string,
        public name: string,
        public emailAddress: string | null,
        public role: UserRoleDTO | null,
        public venueIds: string[] | null,
        public notificationPreferences: UserNotificationPreferencesDTO[],
        public pinCode: string | null
    ) { }
}
